const contractLoanDueInformation = require('./contracts/contractLoanDueInformation/contractLoanDueInformation');
const { ContractLoanPdfViewer } = require('./contracts/contractLoanPdfViewer/contractLoanPdfViewer');
const loansCreditsMoreOptionsButton = require('./loansAndMortgages/loansCreditsMoreOptionsButton/loansCreditsMoreOptionsButton');
const loanHeader = require('./loansAndMortgages/loans/loanHeader/loanHeader');
const loansBlockedAccountsMessage = require('./loansAndMortgages/loansBlockedAccountsMessage/loansBlockedAccountsMessage');
const LoanCollectiveTag = require('./loansAndMortgages/loanCollectiveTag/loanCollectiveTag');

module.exports = {
    contractLoanDueInformation,
    contractLoanPdfViewer: ContractLoanPdfViewer,
    loansCreditsMoreOptionsButton,
    loanHeader,
    loansBlockedAccountsMessage,
    LoanCollectiveTag
};
